import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconGalleryStyle0 = cosmosIconCss;

const CosmosIconGallery$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconGallery extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '7fcad88aca4db9aeedff6281fc366ad3378c2baf', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '9acc6db72766a6b8640f9bf90a8519942ae31d09', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'fff9582f69cbe9087c4e526e6acc233211e97ba6', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M3.563 4a.438.438 0 0 0-.438.438v2.625c0 .241.196.437.438.437h.874a.438.438 0 0 0 .438-.437V4.438A.438.438 0 0 0 4.438 4h-.875Zm14.875 14a.438.438 0 0 0 .437-.437v-2.625a.438.438 0 0 0-.437-.438h-.875a.438.438 0 0 0-.438.438v2.624c0 .242.196.438.438.438h.875ZM15.375 4.438c0-.242.196-.438.438-.438h2.624c.242 0 .438.196.438.438v2.625a.438.438 0 0 1-.437.437h-2.625a.438.438 0 0 1-.438-.437V4.438ZM6.188 18a.438.438 0 0 0 .437-.437v-2.625a.438.438 0 0 0-.437-.438H3.563a.438.438 0 0 0-.438.438v2.624c0 .242.196.438.438.438h2.625Zm.437-13.562c0-.242.196-.438.438-.438h6.125c.241 0 .437.196.437.438v2.625a.438.438 0 0 1-.437.437H7.062a.438.438 0 0 1-.437-.437V4.438ZM14.938 18a.438.438 0 0 0 .437-.437v-2.625a.438.438 0 0 0-.437-.438H8.811a.438.438 0 0 0-.437.438v2.624c0 .242.196.438.438.438h6.124ZM3.124 9.688c0-.242.196-.438.438-.438h6.124c.242 0 .438.196.438.438v2.624a.438.438 0 0 1-.437.438H3.561a.438.438 0 0 1-.437-.437V9.687Zm9.188-.438a.438.438 0 0 0-.438.438v2.624c0 .242.196.438.438.438h6.124a.438.438 0 0 0 .438-.437V9.687a.438.438 0 0 0-.437-.437h-6.125Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconGalleryStyle0; }
}, [1, "cosmos-icon-gallery", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-gallery"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-gallery":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconGallery$1);
            }
            break;
    } });
}

const CosmosIconGallery = CosmosIconGallery$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconGallery, defineCustomElement };
